import { render, staticRenderFns } from "./cupon.vue?vue&type=template&id=a8770e94&"
import script from "./cupon.vue?vue&type=script&lang=js&"
export * from "./cupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports